export default __webpack_public_path__ + "static/media/640_dummy2016-kuenstler02-mobile-de.083c7c86.png";